import './BeginConfigure.scss';
import Card from 'components/chrome/Card';
import InfoBubble from 'components/chrome/InfoBubble';
import React from 'react';
import Sitemap from 'components/app/Sitemap'
import { Button } from 'primereact/button';
import { Dropdown } from 'primereact/dropdown';
import { InputSwitch } from 'primereact/inputswitch';
import { InputText } from 'primereact/inputtext';
import { NavLink } from 'react-router-dom';
import { SelectButton } from 'primereact/selectbutton';


const DEFAULT_CONFIG = {
  config_version: '1.0.0',
  config_principal_use: 'realtime',
  config_logs: 'structured',
  config_establishing_connections: {name: 'One-way SSL', code: '1'},
  config_in_session_cipher_suite: {name: 'AES-ECB (256 bit)', code: '1'},
  config_provisioning_material: {name: 'Secure server and device identity', code: '3'},
  config_key_management: {name: 'Managed securely by Axle Medical', code: '1'},
  config_key_rotation_period: '1 year',
};


class DataTypeItem extends React.Component {
  constructor() {
    super();
    this.state = {};
  }

  componentDidMount() {
    this.setState({
      containsPhi: this.props.containsPhi,
      containsPii: this.props.containsPii,
    });
  }

  render() {
    return (
      <div className='DataTypeItem'>
        <ConfigurationItem label='Display name'>
          <InputText
              value={this.state.displayName || this.props.displayName}
              onChange={e => this.setState({displayName: e.value})} />
        </ConfigurationItem>
        <ConfigurationItem
            label='Canonical name'
            info='Must consist of letters, numbers, and underscores only.'>
          <InputText
              value={this.state.canonicalName || this.props.canonicalName}
              onChange={e => this.setState({canonicalName: e.value})} />
        </ConfigurationItem>
        <ConfigurationItem label='Type'>
          <SelectButton
              value={this.state.type || this.props.type}
              onChange={e => this.setState({type: e.value})}
              options={[
                {label: 'Number', value: 'number'},
                {label: 'Vector', value: 'vector'},
                {label: 'Burst', value: 'burst'},
                {label: 'String', value: 'string'},
                {label: 'Other', value: 'other'},
              ]} />
        </ConfigurationItem>
        <ConfigurationItem label='Rate'>
          <SelectButton
              value={this.state.qps || this.props.qps}
              onChange={e => this.setState({qps: e.value})}
              options={[
                {label: '0-1 QPS', value: '0-1'},
                {label: '1-10 QPS', value: '1-10'},
                {label: '10-100 QPS', value: '10-100'},
                {label: '100-1000 QPS', value: '100-1000'},
              ]} />
        </ConfigurationItem>
        <ConfigurationItem
            label='Privacy'
            info='Protected health information (PHI) and personally identifiable information (PII).'>
          <div className='phi'>
            <InputSwitch checked={this.state.containsPhi} onChange={e => this.setState({containsPhi: e.value})} />
            <div>This field can contain PHI</div>
          </div>
          <div className='pii'>
            <InputSwitch checked={this.state.containsPii} onChange={e => this.setState({containsPii: e.value})} />
            <div>This field can contain PII</div>
          </div>
        </ConfigurationItem>
      </div>
    );
  }
}


class ConfigurationItem extends React.Component {
  info() {
    if (this.props.info) {
      return (
        <InfoBubble
            text={this.props.info}
            className='infoBubble' />
      );
    }
    return '';
  }

  render() {
    return (
      <div className='ConfigurationItem'>
        <div className='label'>
          {this.props.label}
          {this.info()}
        </div>
        <div className='value'>
          {this.props.children}
        </div>
      </div>
    );
  }
}


class BeginConfigure extends React.Component {

  constructor() {
    super();
    this.sitemap = new Sitemap.Factory().create();
    this.state = DEFAULT_CONFIG;
  }

  sectionHeader() {
    return (
      <div className='section'>
        <div className='subtitle'>Configure a new API</div>
        <p>Set up the options for your data and metadata.</p>
      </div>
    );
  }

  sectionBasics() {
    return (
      <Card 
          className='section'
          header='The basics'
          text='Configure high level settings, or start from a previous API.'
          childrenPadded>
        <ConfigurationItem
            label='Copy from existing'
            info='When you have existing APIs, they will appear here.'>
          <Dropdown
              placeholder='No saved configs' />
        </ConfigurationItem>
        <ConfigurationItem
            label='API version string'
            info='Recommended format is "major.minor.revision".'>
          <InputText
              value={this.state.config_version}
              onChange={e => this.setState({config_version: e.value})}
              />
        </ConfigurationItem>
        <ConfigurationItem label='Principal use type'>
          <SelectButton
              value={this.state.config_principal_use}
              onChange={e => this.setState({config_principal_use: e.value})}
              options={[
                {label: 'Real-time', value: 'realtime'},
                {label: 'Near-real-time', value: 'nearrealtime'},
                {label: 'Batch', value: 'batch'},
              ]} />
        </ConfigurationItem>
        <ConfigurationItem label='Log collection'>
          <SelectButton
              value={this.state.config_logs}
              onChange={e => this.setState({config_logs: e.value})}
              options={[
                {label: 'Structured', value: 'structured'},
                {label: 'Unstructured', value: 'unstructured'},
              ]} />
        </ConfigurationItem>
      </Card>
    );
  }

  sectionDataConfig() {
    return (
      <div className='section'>
        <Card
            header='Data types'
            text='Add an entry for each distinct type of data your device collects.'
            childrenPadded>
          <div className='dataTypeItems'>
            <DataTypeItem
                canonicalName='pulse_rate'
                displayName='Pulse Rate'
                type='number'
                qps='1-10'
                containsPhi />
            <DataTypeItem
                canonicalName='pulse_ox'
                displayName='Pulse Oximetry'
                type='number'
                qps='0-1'
                containsPhi />
            <DataTypeItem
                canonicalName='ecg'
                displayName='ECG'
                type='burst'
                qps='100-1000'
                containsPhi />
            </div>
          <Button icon='pi pi-plus' label='Add' />
        </Card>
      </div>
    );
  }

  sectionSecurityConfig() {
    return (
      <div className='section'>
        <Card
            header='Security'
            text='Configure communication protocol and key management settings.'
            childrenPadded>

          <ConfigurationItem
              label='Establishing connections'
              info='Learn more about how these are implemented, and what features will be supported depending on this choice.'>
            <Dropdown
                optionLabel='name'
                options={[
                  {name: 'One-way SSL', code: '1'},
                  {name: 'Two-way SSL', code: '2'},
                  {name: 'Pre-shared asymmetric key', code: '3'},
                  {name: 'Pre-shared symmetric key', code: '4'},
                  {name: 'Custom', code: '5'},
                ]}
                value={this.state.config_establishing_connections}
                onChange={e => this.setState({config_establishing_connections: e.value})} />
          </ConfigurationItem>
          <ConfigurationItem
              label='In-session cipher suite'
              info='Learn more about the security properties of these options.'>
            <Dropdown
                optionLabel='name'
                options={[
                  {name: 'AES-ECB (256 bit)', code: '1'},
                  {name: 'AES-ECB (128 bit)', code: '2'},
                  {name: 'AES-CBC (256 bit)', code: '3'},
                  {name: 'AES-CBC (128 bit)', code: '4'},
                  {name: 'AES-CTR (256 bit)', code: '5'},
                  {name: 'AES-CTR (128 bit)', code: '6'},
                ]}
                value={this.state.config_in_session_cipher_suite}
                onChange={e => this.setState({config_in_session_cipher_suite: e.value})} />
          </ConfigurationItem>
          <ConfigurationItem
              label='Provisioning devices'
              info='Devices will need to receive secure key material before being used.'>
            <Dropdown
                optionLabel='name'
                options={[
                  {name: 'Secure server identity', code: '1'},
                  {name: 'Secure device identity', code: '2'},
                  {name: 'Secure server and device identity', code: '3'},
                ]}
                value={this.state.config_provisioning_material}
                onChange={e => {console.log(e.value);this.setState({config_provisioning_material: e.value})}} />
          </ConfigurationItem>
          <ConfigurationItem label='Key management'>
            <Dropdown
                optionLabel='name'
                options={[
                  {name: 'Managed securely by Axle Medical', code: '1'},
                  {name: 'Managed externally', code: '2'},
                ]}
                value={this.state.config_key_management}
                onChange={e => this.setState({config_key_management: e.value})} />
          </ConfigurationItem>
          <ConfigurationItem label='Key rotation period'>
            <SelectButton
                value={this.state.config_key_rotation_period}
                onChange={e => this.setState({config_key_rotation_period: e.value})}
                options={[
                  {label: '3 Months', value: '3 months'},
                  {label: '6 Months', value: '6 months'},
                  {label: '1 Year', value: '1 year'},
                  {label: 'Never', value: 'never'},
                ]} />
          </ConfigurationItem>

        </Card>
      </div>
    );
  }

  sectionContinue() {
    return (
      <div className='section'>
        <p>You'll have a chance to review before committing this configuration.</p>
        <div className='right'>
          <NavLink to={this.sitemap.getNextUrl()}>
            <Button icon='pi pi-chevron-right' iconPos='right' label='Continue' />
          </NavLink>
        </div>
      </div>
    );
  }

  render() {
    return (
      <div className='BeginConfigure'>
        {this.sectionHeader()}
        {this.sectionBasics()}
        {this.sectionDataConfig()}
        {this.sectionSecurityConfig()}
        {this.sectionContinue()}
      </div>
    );
  }
}


export default BeginConfigure;
